import {
  isNoChargeReturnLine,
  resolveOrderLineCharge,
  type ReturnPricingOrderLike
} from '@washday/utilities';

type OrderLineChargeInput = {
  quantity?: number;
  qty?: number;
  type?: string;
  minimumBillableQuantity?: number | null;
  price?: number;
  expressPrice?: number;
  extraAmount?: number;
  manualUnitPrice?: number | null;
  discountAmount?: number;
  discountAmountMode?: 'per_unit' | 'line_total';
  isBuyAndGetProduct?: boolean;
  isFreeItem?: boolean;
  returnSourceOrderLineId?: string;
};

export const getOrderLineCharge = (
  line: OrderLineChargeInput,
  isExpress: boolean,
  returnPricing: ReturnPricingOrderLike = {}
) => {
  const charge = resolveOrderLineCharge(line, isExpress);
  const nominalUnitPrice =
    charge.actualQuantity > 0
      ? charge.subtotalBeforeDiscount / charge.actualQuantity
      : 0;

  if (isNoChargeReturnLine(returnPricing, line)) {
    return {
      ...charge,
      discountTotal: 0,
      total: 0,
      effectiveUnitPrice: 0,
      billableUnitPrice: 0,
      unitPrice: 0,
      unitPriceBeforeDiscount: nominalUnitPrice,
      nominalUnitPrice,
      nominalTotal: charge.total
    };
  }

  return {
    ...charge,
    unitPrice: charge.effectiveUnitPrice,
    unitPriceBeforeDiscount: nominalUnitPrice
  };
};

export const computeBillableOrderSubtotal = (
  products: OrderLineChargeInput[],
  isExpress: boolean,
  returnPricing: ReturnPricingOrderLike = {}
): number =>
  products.reduce((subtotal, product) => {
    if (!product || product.isBuyAndGetProduct || product.isFreeItem) {
      return subtotal;
    }
    const charge = getOrderLineCharge(
      { ...product, discountAmount: 0 },
      isExpress,
      returnPricing
    );
    return subtotal + charge.total;
  }, 0);
